import { Link, useNavigate, useLocation } from 'react-router-dom';
import { LogOut, Plus, LayoutDashboard, Store, User } from 'lucide-react';

interface DashboardHeaderProps {
  userName: string;
  onCreateCampaign: () => void;
}

export function DashboardHeader({ userName, onCreateCampaign }: DashboardHeaderProps) {
  const navigate = useNavigate();
  const location = useLocation();

  const handleLogout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    navigate('/');
  };

  const isActive = (path: string) => location.pathname === path;

  const navLinkClass = (path: string) =>
    isActive(path)
      ? 'inline-flex items-center px-3 py-1.5 text-sm font-medium text-indigo-600 bg-indigo-50 rounded-lg'
      : 'inline-flex items-center px-3 py-1.5 text-sm font-medium text-gray-600 hover:text-indigo-600 hover:bg-gray-50 rounded-lg transition-colors';

  return (
    <header className="bg-white border-b sticky top-0 z-40">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16">
          {/* Logo + nav */}
          <div className="flex items-center space-x-6">
            <Link to="/" className="flex items-center space-x-2">
              <img src="/isotipo.png" alt="DonaApp" className="h-8 w-8" />
              <img src="/logotipo.png" alt="DonaApp" className="h-5 hidden sm:block" />
            </Link>
            <nav className="hidden md:flex items-center space-x-1">
              <Link to="/dashboard" className={navLinkClass('/dashboard')}>
                <LayoutDashboard className="w-4 h-4 mr-1.5" /> Dashboard
              </Link>
              <Link to="/marketplace" className={navLinkClass('/marketplace')}>
                <Store className="w-4 h-4 mr-1.5" /> Marketplace
              </Link>
              <Link to="/profile" className={navLinkClass('/profile')}>
                <User className="w-4 h-4 mr-1.5" /> Perfil
              </Link>
            </nav>
          </div>

          {/* Actions */}
          <div className="flex items-center space-x-3">
            <button
              onClick={onCreateCampaign}
              className="inline-flex items-center px-4 py-2 text-sm font-medium text-white bg-indigo-600 rounded-lg hover:bg-indigo-700 transition-colors"
            >
              <Plus className="w-4 h-4 mr-1.5" />
              <span className="hidden sm:inline">Nueva Campaña</span>
              <span className="sm:hidden">Nueva</span>
            </button>
            <div className="hidden sm:flex items-center pl-3 border-l border-gray-200">
              <span className="text-sm text-gray-600 mr-3">{userName}</span>
              <button
                onClick={handleLogout}
                className="p-2 text-gray-400 hover:text-red-500 hover:bg-red-50 rounded-lg transition-colors"
                title="Cerrar sesión"
              >
                <LogOut className="w-4 h-4" />
              </button>
            </div>
            <button
              onClick={handleLogout}
              className="sm:hidden p-2 text-gray-400 hover:text-red-500 rounded-lg"
              title="Cerrar sesión"
            >
              <LogOut className="w-4 h-4" />
            </button>
          </div>
        </div>
      </div>
    </header>
  );
}
